module.exports = "/_next/static/images/office-pink-icon-c2cface2b4f2f16b13aebaa374e2a0e2.svg";